import axios from '../../../context/axiosConfig'
import { useState, useEffect } from 'react';
import { usePaginationPrzelewy } from '../../../context/PaginationContextPrzelewy';
import { notification } from 'antd';
const WygenerowaneGetList = () => {
    const {pagination, setPagination} = usePaginationPrzelewy()
    const [data, setData] = useState([])
    useEffect(() => {
      let active = true
      setPagination(current => ({...current, loading: true}))
      const fetchData = async () => {
          try {
              const response = await axios.post("/przelewy/get/list/grouped", {
                pagination: pagination
              }, { timeout: 20000 });
              if (active) {
                  setData(response.data)
                  if (pagination.current > 1 && pagination.current > Math.ceil(response.data.total / pagination.pagesize)) {
                      setPagination(current => ({...current, current: 1}))
                  }
              }
          } catch (error) {
              if (active) {
                  console.error("Failed to load generated Przelewy list", error?.response?.status || error?.code || "unknown error")
                  notification.error({
                      message: "Nie udało się załadować listy wygenerowanych przelewów",
                      description: "Sprawdź połączenie z serwerem i spróbuj ponownie."
                  })
              }
          } finally {
              if (active) {
                  setPagination(current => ({...current, loading: false}))
              }
          }
      }
      fetchData()
      return () => {
          active = false
      }
    },[pagination.current, pagination.pagesize, pagination.reload, pagination.generated, pagination.search])
    return data
  };
export default WygenerowaneGetList;